





























import { editFactory } from '@/main/pages';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
	},
	computed: {
		mutationsMappers() {
			return { rabatSk: `${this.storeUri}/${editMutations.SLEVAMAT_RABAT_SK_SELECT_MAPPER}` };
		},
		rabatSkFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
	},
	methods: {
		RabatSkMapper({ data }: { data: { value: string; text: string } }) {
			this.RabatSk = data.value;
			this.RabatSkText = data.text;
		},
	},
});
